import enphase from "~/assets/photo/battery-only-proposal/enphase-iq-battery.png"
import powerwall from "~/assets/photo/battery-only-proposal/powerwall3.png"
import solarEdgeNexis from "~/assets/photo/battery-only-proposal/solaredge-nexis.webp"

export type BatteryProductShot = { src: string; alt: string }

/** First match wins, so Tesla is tested before the broader patterns. */
const PRODUCT_SHOTS: (BatteryProductShot & { match: RegExp })[] = [
  {
    match: /(?:tesla|powerwall)/i,
    src: powerwall,
    alt: `Tesla Powerwall home battery system`,
  },
  {
    match: /enphase/i,
    src: enphase,
    alt: `Enphase home battery system`,
  },
  {
    match: /nexis/i,
    src: solarEdgeNexis,
    alt: `SolarEdge Nexis home battery system`,
  },
]

/** The product shot for a battery's "{manufacturer} {name}", or null when none matches. */
export const batteryProductShot = (
  manufacturer: string | null | undefined,
  name: string | null | undefined,
): BatteryProductShot | null => {
  const model = [manufacturer, name].filter(Boolean).join(` `)
  const shot = PRODUCT_SHOTS.find(({ match }) => match.test(model))
  return shot ? { src: shot.src, alt: shot.alt } : null
}
